import axios from 'axios'

export default {
  GET_INFO_BY_INN({ commit, dispatch }, { inn, trigger }) {
    commit('SET_LOADING', { payload: true, type: trigger })
    axios({
      method: 'POST',
      url: '/api/CustomerRegistration/GetNameByInn',
      data: { inn }
    })
      .then(response => {
        commit('GET_INFO_BY_INN_SUCCESS', { payload: response.data, type: trigger })
        commit('SET_LOADING', { payload: false, type: trigger })
        commit('SETUP_EDITABLE_FIELD', { payload: true, type: trigger })
      })
      .catch(error => {
        commit('GET_INFO_BY_INN_ERROR', error.response.data.message)
        // dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
        commit('SET_LOADING', { payload: false, type: trigger })
        if (error.response.data.code === 9) commit('SETUP_EDITABLE_FIELD', { payload: true, type: trigger })
      })
  },
  EDIT_PHONE_OR_PIN({ commit, dispatch }, { userId, data }) {
    const sessionId = sessionStorage.getItem('token')
    return axios({
      method: 'POST',
      url: `/api/CustomerRegistration/EditPhoneOrPin/${sessionId}/${userId}`,
      data
    })
      .then(() => {
        dispatch('NOTIFICATION', { open: true, color: 'success', text: 'Данные успешно изменены.' })
      })
      .catch(error => {
        dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: error.response.data.message || 'Ошибка. Обратитесь к администратору.'
        })
      })
  },
  SET_PAUSE_TO_PAYMENT({ dispatch, state }, { inn, organizationInn }) {
    const sessionId = sessionStorage.getItem('token')
    axios({
      method: 'POST',
      url: !organizationInn
        ? `/api/CustomerRegistration/CancelUserPayment/${sessionId}/${inn}`
        : `/api/CustomerRegistration/CancelEmployeePayment/${sessionId}/${inn}/${organizationInn}`
    })
      .then(response => {
        if (response.data.success) {
          dispatch('NOTIFICATION', { open: true, color: 'success', text: 'Данные успешно изменены.' })
          dispatch(
            'GET_SUBSCRIBERS_LIST',
            this.state.subscribers.searchValue
              ? {
                innFilter: this.state.subscribers.searchValue,
                nameFilter: this.state.subscribers.searchValue,
                amount: 10,
                page: this.state.subscribers.page
              }
              : { amount: 10, page: this.state.subscribers.page }
          )
        }
      })
      .catch(error => {
        dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: error.response.data.message || 'Ошибка. Обратитесь к администратору.'
        })
      })
  },
  REGISTRATION_CUSTOMERS({ dispatch }, { formData, endpointType, dispatchType }) {
    const sessionId = sessionStorage.getItem('token')
    return axios({
      method: 'POST',
      url: `/api/CustomerRegistration/${endpointType}/${sessionId}`,
      data: formData
    })
      .then(() => {
        dispatch(`${dispatchType}`, { amount: 10, page: 1 })
      })
      .catch(error => {
        const { data } = error.response
        dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: (data || {}).message || 'Неизвестная ошибка. Обратитесь к администретору.'
        })
      })
  }
}
